import React, { useMemo } from 'react';
import './style.scss';
import clsx from 'clsx';
import CarouselWithInformativeCardsGrid from './shared/grid/index.js';
import CarouselWithInformativeCardsSlide from './shared/slide';
import Carousel from '../Shared/components/Carousel';
import { withTranslation } from 'react-i18next';
import { SwiperSlide } from 'swiper/react/swiper-react.js';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const CarouselWithInformativeCards = (props) => {
  const { fields, params, i18n } = props;
  const isGrid = props.params.isCarousel !== '1';
  const slides = fields.items;
  const colors = useMemo(() => {
    const available = [...Array(6)].map((_, i) => i + 1);
    let justUsed = 6;
    return slides.map((slide, index) => {
      if (index < available.length) return index + 1;
      const filtered = available.filter((el) => el !== justUsed);
      const i = Math.trunc(Math.random() * filtered.length);
      justUsed = filtered[i];
      return filtered[i];
    });
  }, [slides]);

  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="CarouselWithInformativeCards" />;
  }

  return (
    <div className={clsx('CarouselWithInformativeCards', slides?.length === 1 && 'one-item')}>
      {isGrid && (
        <CarouselWithInformativeCardsGrid
          {...props}
          className={clsx('carousel-with-informative-cards-grid', 'add-margins', params.Styles)}
          colors={colors}
        />
      )}
      <Carousel
        fields={fields}
        params={params}
        lang={i18n.language}
        className={clsx(
          isGrid && 'carousel-with-informative-cards-carousel',
          'add-margins',
          params.Styles
        )}
        arrow="white"
      >
        {slides.map((card, index) => (
          <SwiperSlide key={index}>
            <CarouselWithInformativeCardsSlide data={card} color={colors[index]} />
          </SwiperSlide>
        ))}
      </Carousel>
    </div>
  );
};

export default withTranslation()(CarouselWithInformativeCards);
